import React from "react";
import { cn } from "../utils";

/** Small ring spinner. tone: "gray" (default) or "white" for filled buttons. */
export function Spinner({ size = 13, tone = "gray", className }) {
  return (
    <span
      aria-hidden="true"
      className={cn("aone-spin", tone === "white" && "aone-spin--white", className)}
      style={{ width: size, height: size }}
    />
  );
}

export default Spinner;
